import { productsSlice } from '../slices/productsSlice';

export default productsSlice.reducer;
